export default "__VITE_ASSET__BLsJqtcJ__"